export const Letter = "abcdefghijklmnopqrstuvwxyz";



// WEBPACK FOOTER //
// ./src/Letter.js